import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-test-link',
    templateUrl: './test-link.component.html',
    styleUrls: ['./test-link.component.scss']
})
export class TestLinkComponent implements OnInit {
    projectId = '5f718c5d0e892e00017a6a5f';
    roomId = '601d013a5304b961e3d4e140';

    constructor(private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            const key = params.key;
            if (key) {
                const result = key.split('-');
                this.projectId = result[0] ? result[0] : this.projectId;
                this.roomId = result[1] ? result[1] : this.roomId;
            }
        });
    }

    ngOnInit(): void {
    }

    getHost(): string {
        return window.location.origin;
    }

}
